// Meta Pixel helpers. The base code in public/index.html loads fbq and sends
// the first PageView; these send the shopping events Meta Ads optimises for.
// If the script is blocked (ad blockers), fbq is missing and calls are no-ops.

const CURRENCY = "USD";

export const track = (event, params) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", event, params);
  }
};

export const trackViewContent = (product) =>
  track("ViewContent", {
    content_ids: [product.sku],
    content_name: product.name,
    content_category: product.subcategory,
    content_type: "product",
    value: product.price,
    currency: CURRENCY,
  });

export const trackAddToCart = (product) =>
  track("AddToCart", {
    content_ids: [product.sku],
    content_name: product.name,
    content_type: "product",
    value: product.price,
    currency: CURRENCY,
  });

const cartParams = (items, value) => ({
  content_ids: items.map((item) => item.sku),
  contents: items.map((item) => ({ id: item.sku, quantity: item.quantity })),
  content_type: "product",
  num_items: items.reduce((sum, item) => sum + item.quantity, 0),
  value,
  currency: CURRENCY,
});

export const trackInitiateCheckout = (items, value) =>
  track("InitiateCheckout", cartParams(items, value));

export const trackPurchase = (items, value) =>
  track("Purchase", cartParams(items, value));
